class NoStoreFoundError extends Error {
  constructor() {
    super('No store was found from Store Search Service');
    this.name = "NoStoreFoundError";
  }
}

export default NoStoreFoundError;